// extracted by mini-css-extract-plugin
export default {"manageTags":"ManageTags_manageTags__B27mf"};